import { useEffect, useState } from 'react';

import { type TEditColumnData } from 'components/data/types';
import { Button, Modal, Tooltip } from 'components/ui';

import BulkEditForm from './BulkEditForm';

interface Props {
  records: any[];
  columns: TEditColumnData[];
  requiredFields?: string[];
  onSubmit: (data: any) => void;
  btnDisplay?: boolean;
  disabled?: boolean;
  disabledMessage?: string;
  additionalTooltipContent?: string;
  additionalFooterContent?: React.ReactNode;
}

export const BulkEdit: React.FunctionComponent<Props> = ({
  records,
  columns,
  requiredFields = [],
  onSubmit,
  btnDisplay = true,
  disabled = false,
  disabledMessage = '',
  additionalTooltipContent = '',
  additionalFooterContent,
}) => {
  const [modalVisible, setModalVisible] = useState(false);

  function closeModal() {
    setModalVisible(false);
  }

  useEffect(() => {
    return () => {
      setModalVisible(false);
    };
  }, []);

  return (
    <>
      {btnDisplay ? (
        <Tooltip title={disabled ? disabledMessage : ''}>
          <div>
            <Button
              id="bulk-edit-button"
              data-testid="bulk-edit-button"
              onClick={() => setModalVisible(true)}
              disabled={disabled}
            >
              Edit Selected
            </Button>
          </div>
        </Tooltip>
      ) : (
        <div onClick={() => setModalVisible(true)}>Edit Selected</div>
      )}
      <Modal
        title={`Edit ${records.length} items`}
        visible={modalVisible}
        onCancel={closeModal}
        footer={null}
        destroyOnClose
      >
        <BulkEditForm
          columns={columns}
          records={records}
          requiredFields={requiredFields}
          onSubmit={onSubmit}
          onClose={closeModal}
          additionalTooltipContent={additionalTooltipContent}
          additionalFooterContent={additionalFooterContent}
        />
      </Modal>
    </>
  );
};
